import redBallLogo from '../../media/red-ball.png'

export default function Home() {
  return (
    <>
      <div className='history-sec'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-12 text-center'>
              <div className='top-heading m-auto'>
                <img src={redBallLogo} alt='Red Ball Logo' />
                <span> BACKGROUND </span>
              </div>
              <h2>Maverick's History</h2>
              <p className='history-text m-auto py-2'>
                The Mavericks Sports Foundation is a non-profit that's all about using cricket to do
                good in the community. Our cricket club plays in different leagues and events,
                pushing teamwork, discipline, and good sportsmanship, all while helping young people
                through sports. We also put together community tournaments and events that get local
                businesses, groups, and people who love cricket involved. As a non-profit, we're all
                about being open and doing what's right. We want to allow young athletes to train at
                good places, learn from coaches, and get advice that sets them up to grow in sports
                and in life. We're really into cricket and giving back, so we want to get young
                people going, knit the community closer, and make a real difference.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
